(function () {
    'use strict';

    angular
        .module('app')
        .controller('layout', layout);

    layout.$inject = ['$state', '$rootScope', '$scope', 'sidebarservice', 'loginService', 'ddService', 'viewerService']; 

    function layout($state, $rootScope, $scope, sidebarservice, loginService, ddService, viewerService) {
        /* jshint validthis:true */
        var vm = this;
        vm.viewerService = viewerService;
        vm.title = 'layout';
        vm.marginRight = 0;
        vm.state = $state;
        $scope.isRouteLoading = false;
        vm.sidebarService = sidebarservice;
        vm.ddService = ddService;
        vm.loginService = loginService;
        vm.paneResize = function (size) {
            $rootScope.$broadcast('dd:resize', size);
        }

    }
})();
